import { flyToOptions } from "@/utils";

const initialLayersDatatypes = ["nodes", "links"];

export class ModelController {
  constructor(parent) {
    this.parent = parent;
    this.$store = parent.$store;
    this.mapgl = parent.mapgl;
  }

  toggleModelOn() {
    const { modelId } = this.parent.$route.params;

    if (!modelId) return;

    this.flyToModel(modelId);
    this.toggleOnInitialLayers();
  }

  toggleModelOff() {
    const { activeLayers } = this.$store.state.calculations;

    [...activeLayers].forEach(id =>
      this.parent.controllers.layers.toggleLayerOff(id)
    );
  }

  // helpers
  toggleOnInitialLayers() {
    const { model } = this.$store.state.calculations;
    const { children } = model;

    children
      .filter(l => initialLayersDatatypes.includes(l.datatype))
      .forEach(({ id }) =>
        this.parent.controllers.layers.toggleLayerOn(id, true)
      );
  }

  async flyToModel(id) {
    if (!this.$store.state.map.extent[id]) {
      const { data } = await this.$store.dispatch("REQUEST", {
        url: `geom_extent/${id}?`
      });
      const extent = data;

      this.$store.commit("SET_LAYER_EXTENT", { id, extent });
    }

    const extent = this.$store.state.map.extent[id];
    const { center, zoom } = this.mapgl.cameraForBounds(
      [extent.slice(0, 2), extent.slice(2)],
      { padding: { top: 10, bottom: 10, left: 10, right: 10 } }
    );
    this.mapgl.flyTo({
      center,
      zoom,
      ...flyToOptions
    });
  }
}
